import React from "react";
import SMACDashboard from "./index";
import {VIEW_BY_ACQUISITION} from "./constants";


export default function DashboardAcquisitionInstance() {
    return <SMACDashboard title="SMAC Acquisition" fixedTabValue={VIEW_BY_ACQUISITION}/>
}